import React from 'react';

interface LoadingProps {
    text?: string;
}
export const Loading = (props: LoadingProps) => <div className="small text-muted pas">{props.text || 'loading'}&hellip;</div>;
